import React from 'react';
import ManageOrders from '../components/ShipturtleOrders/ManageOrders';

function ShipturtleOrders() {
  return <ManageOrders />;
}

export default ShipturtleOrders;
